import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { LoginService } from '../../services/login.service';

/**
 * Landing page Auth0 redirects to (result_url) after the user verifies their
 * email. Re-syncs the fresh email_verified into the current session — without a
 * re-login — and sends the user back into the app.
 */
@Component({
  selector: 'app-verify-callback',
  templateUrl: './verify-callback.component.html',
})
export class VerifyCallbackComponent implements OnInit {

  error: boolean = false;
  processing: boolean = true;

  constructor(
    private router: Router,
    private loginService: LoginService,
  ) {}

  ngOnInit(): void {
    this.loginService.refreshVerification().subscribe({
      next: () => {
        this.processing = false;
        this.router.navigateByUrl('companies?referral=login');
      },
      error: () => {
        // If the session is gone (e.g. token expired), fall back to login.
        this.processing = false;
        this.error = true;
        this.router.navigate(['/login']);
      },
    });
  }
}
